// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import Component from "./-components/component";
import getPharmacyID from "@/utils/pharmacy_code";
import { httpClient } from "@/httpClient";
import { CurrentlyActiveShift } from "@/routes/(pharma)/_layout/overview/-data/schema";
import { pharmacyClient } from "@/connect";
import { Level, StockPointType } from "@/gen/auth/common_pb";

type Props = {
  activeShiftFound: boolean;
  last_shift_system_ended: boolean;
  last_shift_id: string;
}

const API_URL = import.meta.env.VITE_API_URL as string

export const Route = createFileRoute("/(pharma)/_layout/sales/")({
  component: Component,
  loader: async (): Promise<Props> => {

    const level = localStorage.getItem("level");
    const stockPointType = localStorage.getItem("stockPointType");

    console.log("Level:", level);
    console.log("Stock Point Type:", stockPointType);

    console.log(level !== Level.STOCK_POINT.toString() || (stockPointType !== StockPointType.CONSUMING.toString() && stockPointType !== StockPointType.SELLING.toString()))

    if (level !== Level.STOCK_POINT.toString() || (stockPointType !== StockPointType.CONSUMING.toString() && stockPointType !== StockPointType.SELLING.toString())) {
      // If the user is not a stock point or consuming/selling stock point, we can send them back to the previous page
      throw redirect({
        to: "/overview",
        replace: true,
      })
    }

    const shiftInfo = await pharmacyClient.currentActiveShift({})

    return {
      activeShiftFound: shiftInfo.currentlyActive,
      last_shift_system_ended: shiftInfo.lastActiveShift?.systemEnded || false,
      last_shift_id: shiftInfo.lastActiveShift?.shiftId || "",
    }
  }
});